import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { User } from '@jfw/angular/shared/firebase/auth';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatSelect } from '@angular/material/select';
import { RouterLink, RouterLinkActive } from '@angular/router';
import {
  Dealer,
  EnvVersion,
  DealerPortalModuleAccessGroup as ModuleGroup,
} from '@jfw/types';

interface DealerIdForm {
  dealerId: FormControl<string>;
}

@Component({
  selector: 'app-header-desktop',
  templateUrl: './desktop.component.html',
  styleUrls: ['./desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatIcon,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
    RouterLink,
    RouterLinkActive,
  ],
})
export class HeaderDesktopComponent {
  public readonly headerLogo = input.required<string>();

  public readonly headerTheme = input.required<string>();

  public readonly servedEnvironment = input.required<EnvVersion>();

  public readonly enableDealerReports = input.required<boolean>();

  public readonly dealerIdForm = input.required<FormGroup<DealerIdForm>>();

  public readonly firebaseUser = input.required<User | null>();

  public readonly currentDealer = input.required<Dealer | null>();

  public readonly userDealers = input.required<Dealer[]>();

  public readonly displayName = input.required<string>();

  public readonly newSite = input.required<boolean>();

  public readonly moduleGroups = input.required<ModuleGroup[] | null>();

  // EXT-6239: shows the header feedback button.
  public readonly enableFeedback = input.required<boolean>();

  public readonly openFeedback = output<void>();

  public readonly newDefaultDealerId = output<string>();
}
